import React, { Suspense, lazy } from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
const BeyondGallery = lazy(() => import('./BeyondGallery'));

const CARDS = [
  { id: 'internship-hub', title: 'Internship Hub', description: 'Learn by doing with guided, skill-based internships.', image: '/beyond/internship-hub.jpg' },
  { id: 'live-events', title: 'Live Events & Programs', description: 'Knowledge-packed sessions, competitions, and meetups.', image: '/beyond/live-events.jpg' },
  { id: 'beyond-gallery-card', title: 'Beyond Gallery', description: 'A space for creativity, innovation, and achievements.', image: '/beyond/beyond-gallery.jpg' },
  { id: 'community-club', title: 'Community Club', description: 'Join a network of builders, thinkers, and leaders.', image: '/beyond/community-club.png' },
];

const BeyondTheWalls: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      id="beyond-the-classroom"
      sx={{
        position: 'relative',
        zIndex: 1,
      }}
    >
      {/* Beyond the Classroom section - dark theme, 4 cards */}
      <Box
        className="beyond"
        sx={{
          padding: { xs: '60px 0', md: '80px 0' },
          color: '#fff',
          background: '#000',
        }}
      >
        <Box
          className="container"
          sx={{
            width: '85%',
            maxWidth: 1400,
            margin: '0 auto',
          }}
        >
          <motion.div
            initial={false}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0 }}
          >
            <Typography
              component="h2"
              sx={{
                fontFamily: 'Georgia, "Times New Roman", serif',
                fontSize: { xs: '2.25rem', md: '48px' },
                fontWeight: 400,
                mb: 2,
                color: '#fff',
              }}
            >
              Beyond the Classroom
            </Typography>
            <Typography
              component="p"
              sx={{
                color: 'rgba(255,255,255,0.85)',
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.6,
                mb: 5,
                maxWidth: 560,
              }}
            >
              Opportunities beyond academics to explore, create, and connect.
            </Typography>

            <Box
              className="cards"
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
                gap: 3,
              }}
            >
              {CARDS.map((card, index) => (
                <motion.div
                  key={card.title}
                  id={card.id}
                  initial={false}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0 }}
                >
                  <Box
                    className="card"
                    onClick={() => {
                      if (card.id === 'beyond-gallery-card') navigate('/beyond-gallery');
                      else if (card.id === 'community-club') navigate('/community-club');
                      else if (card.id === 'internship-hub') navigate('/internship-hub');
                      else if (card.id === 'live-events') navigate('/live-events');
                    }}
                    sx={{
                      height: { xs: 320, md: 420 },
                      borderRadius: '14px',
                      backgroundImage: `url(${card.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      position: 'relative',
                      overflow: 'hidden',
                      cursor: 'pointer',
                      transition: 'transform 0.4s ease',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        background: 'linear-gradient(to top, rgba(0,0,0,0.92), rgba(0,0,0,0.4) 40%, rgba(0,0,0,0.1))',
                      },
                      '&:hover': {
                        transform: 'scale(1.05)',
                      },
                      '@media (hover: none)': {
                        transition: 'none',
                        '&:hover': {
                          transform: 'none',
                        },
                      },
                    }}
                  >
                    <Box sx={{ position: 'absolute', bottom: 20, left: 20, right: 20, zIndex: 2 }}>
                      <Typography
                        component="span"
                        sx={{
                          display: 'block',
                          fontSize: { xs: '1.1rem', md: '22px' },
                          color: '#fff',
                          fontFamily: 'Georgia, "Times New Roman", serif',
                          fontWeight: 500,
                          mb: 0.5,
                        }}
                      >
                        {card.title}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          display: 'block',
                          fontSize: { xs: '0.8rem', md: '0.9rem' },
                          color: 'rgba(255,255,255,0.88)',
                          lineHeight: 1.4,
                        }}
                      >
                        {card.description}
                      </Typography>
                    </Box>
                  </Box>
                </motion.div>
              ))}
            </Box>

            <Suspense fallback={null}>
              <BeyondGallery />
            </Suspense>
          </motion.div>
        </Box>
      </Box>
    </Box>
  );
};

export default BeyondTheWalls;
